"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography,
      palette = _ref.palette;
  return {
    primary: function primary() {
      return {
        fontWeight: typography.fontWeightMedium,
        color: palette.text.primary,
        fontSize: '18px',
        paddingTop: '10px',
        paddingBottom: '10px'
      };
    },
    secondary: function secondary() {
      return {
        fontWeight: typography.fontWeightBold,
        color: palette.text.secondary,
        fontSize: '14px'
      };
    },
    wrapper: {
      display: 'grid',
      columnGap: '10px',
      gridTemplateColumns: '1fr 50px',
      borderBottom: "1px solid ".concat(palette.grey['200'])
    },
    btn: {
      backgroundColor: palette.primary.main,
      color: palette.primary.contrastText,
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.primary.light,
        color: palette.primary.dark
      }
    }
  };
});
var _default = useStyles;
exports["default"] = _default;